import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from '@cbridge-utils/react-redux';
import { NavigationHeaderCreateButton } from '@cbridge-tools/navigation-block';
import { PolicyProtection } from '@cbridge-packages/auth';
import { NodeAction } from '@cbridge-packages/node';
import { useDialogs } from '@cbridge-modules/dialog';
import { NodeFormDialog } from '../_dialogs/NodeFormDialog';

export const CreateNodeButton: FunctionComponent = () => {
  const { t } = useTranslation();
  const dialogs = useDialogs();

  const dispatch = useDispatch();

  const handleCreateNode = async () => {
    const nodeId = await dialogs.open(NodeFormDialog);

    if (nodeId) {
      dispatch(NodeAction.loadList.started({}));
    }
  };

  return (
    <PolicyProtection>
      <NavigationHeaderCreateButton
        label={t('text:configPage.symbolPools.dialog.create.title')}
        onClick={handleCreateNode}
      />
    </PolicyProtection>
  );
};
